export const BASE_CLASS = 'fm-password-field';

export const getClass = (childClass: TemplateStringsArray) =>
  `${BASE_CLASS}${childClass}`;
